// lib/emails/betreffZusatz.ts
// #525/#534: Objekt an den Vorlagen-Betreff hängen — aber nicht, wenn die Vorlage die
// Adresse schon enthält (auch in anderer Schreibweise, z. B. „88,12345“ statt „88, 12345“).

const norm = (s: string) => s.toLowerCase().replace(/[\s,.;:–—-]+/g, '');

export function betreffMitZusatz(betreff: string, zusatz: string | null | undefined): string {
  const b = betreff.trim();
  const z = (zusatz ?? '').trim();
  if (!z) return b;
  // Nur den Adressteil vergleichen („Straße Nr, Ort“ vor „ – Einheit“), Straße + Nr reichen.
  const adresse = z.split(' – ')[0].split(',')[0];
  if (norm(b).includes(norm(z)) || (adresse && norm(b).includes(norm(adresse)))) return b;
  return `${b} – ${z}`;
}
